export const tableSortMixin = {
  data() {
    return {
      orderByField: "id",
      orderByDirection: "DESC",
      directions: ["ASC", "DESC"],
      order: 1,
    };
  },
  methods: {
    orderClass(field) {
      if (this.orderByField != field) return "";
      if (typeof this.orderByDirection === "boolean") {
        return this.orderByDirection ? "asc" : "desc";
      }
      return String(this.orderByDirection).toUpperCase() === "ASC" ? "asc" : "desc";
    },
    toggleOrder(field) {
      if (this.orderByField === field) {
        this.order = 1 - this.order;
      } else {
        this.orderByField = field;
        this.order = 0;
      }
      this.orderByDirection = this.directions[this.order];
    },
  },
};
